import { createStore } from "vuex";

const store = createStore({
    state: {
        authentication: {
            authState: {
                isAuthenticated: false
            },
            user: {}
        }
    },
    getters:{
        getIsAuthenticated : (state) => {
            return state.authentication.authState.isAuthenticated;
        },
        getUserData: (state) => {
            return state.authentication.user;
        }
    },
    mutations: {
        setIsAuthenticated(state, n) {
            state.authentication.authState.isAuthenticated = n;
        }
    },
    actions: {

    }  
    
});

export default store;